var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../../../Icon";
// styles
import "./sidebarFooter.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-sidebarFooter",
};
const SidebarFooter = (_a) => {
    var { iconName, isOpen, className, children } = _a, rest = __rest(_a, ["iconName", "isOpen", "className", "children"]);
    const classList = classNames("tecma-sidebarFooter", { isOpen }, className);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [iconName && _jsx(Icon, { iconName: iconName }), children] })));
};
SidebarFooter.defaultProps = defaultProps;
export default React.memo(SidebarFooter);
